/* eslint-disable comma-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import * as assets from '../assets/index';
import LogoAR from './logo-ar-svg';
import LogoEN from './logo-en-svg';
import './index.scss';

const ns = 'sidebar';

export default ({ list = [], showMenu, setShowMenu }: any) => {
  const { language } = useSelector((state: any) => state.user);
  return (
    <nav className={cn(ns, { [`${ns}--show`]: showMenu })}>
      <div className={`${ns}__logo-container`}>
        <a href="/">
          {language === 'en' ? (
            <LogoEN className={`${ns}__logo`} />
          ) : (
            <LogoAR className={`${ns}__logo`} />
          )}
        </a>
        {/* eslint-disable-next-line react/button-has-type */}
        <button className={`${ns}__close`} onClick={() => setShowMenu()}>
          <assets.ErrorCross />
        </button>
      </div>
      <ul className={`${ns}__list`}>
        {list.map(
          (
            {
              to,
              exact,
              text,
              icon,
              iconClass,
              // tslint:disable-next-line:align
            }: {
              to?: string;
              exact?: boolean;
              text?: string;
              icon?: keyof typeof assets;
              iconClass?: string;
            },
            index?: number
          ) => {
            const Icon = icon && assets[icon] ? assets[icon] : null;
            return (
              <li key={text}>
                <NavLink to={to || '/'} exact={exact}>
                  {Icon !== null && (
                    // @ts-ignore
                    <Icon className={iconClass} />
                  )}
                  {text}
                </NavLink>
              </li>
            );
          }
        )}
      </ul>
    </nav>
  );
};
